import React from 'react';

import Dribble from '../../img/Dribble.png'
import Linkedin from '../../img/linkedin.svg'
import git from '../../img/git.png'

import FooterStyle from './footerStyle';

const Footer = () => {
    return (
        <div className="container">
           <div className="footer">
                <div className="row align-items-center text-center text-lg-left">
                    <div className="col-12 col-lg-6">
                        <a target="_blank" href="https://dribbble.com/nish88277">
                            <img src={Dribble} alt="Dribble"/>
                        </a>
                        <a target="_blank" href="https://www.linkedin.com/in/nishantarora88277">
                            <img src={Linkedin}  alt="Linkedin"/>
                        </a>
                        <a target="_blank" href="https://github.com/Nishant88277?tab=repositories">
                            <img src={git}  alt="git"/>
                        </a>
                    </div>
                    <div className="col-12 col-lg-6">
                        <p className="m-0 text-white text-lg-right pt-2 pt-lg-0">
                            @Copyright 2020
                        </p>
                    </div>
                </div>
           </div>
            <FooterStyle/>
        </div>
    );
};

export default Footer;
